import * as React from 'react';
import { connect } from 'react-redux';

import { Widget } from '../../store/models';

import WidgetPrintCanvas from './WidgetPrintCanvas';

interface IProps {
    widgets: Widget[]
}

const WidgetPrintCanvasContainer: React.StatelessComponent<IProps> = (props: IProps) => {
    const { widgets } = props;

    return (
        <WidgetPrintCanvas
            widgets={widgets}
        />
    );
}

WidgetPrintCanvasContainer.propTypes = {
    widgets: React.PropTypes.array.isRequired
};

const mapStateToProps = state => ({
    widgets: state.reportTemplate.widgets,
});

export default connect(
    mapStateToProps,
    {}
)(WidgetPrintCanvasContainer);


// WEBPACK FOOTER //
// ./src/components/widgetCanvas/WidgetPrintCanvasContainer.tsx